import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-wapi-front__header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMobile = _resolveComponent("HeaderMobile")!
  const _component_HeaderDesktop = _resolveComponent("HeaderDesktop")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "app-wapi-front",
    style: _normalizeStyle(
			_ctx.vue_app_theme === _ctx.THEMES
				? '--theme-color: rgb(37, 211, 102)'
				: '--theme-color: rgb(40, 167, 232)'
		)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.device.isMobile)
        ? (_openBlock(), _createBlock(_component_HeaderMobile, {
            key: 0,
            channels: _ctx.channels,
            "is-notify": _ctx.isNotify
          }, null, 8, ["channels", "is-notify"]))
        : (_openBlock(), _createBlock(_component_HeaderDesktop, {
            key: 1,
            balance: _ctx.formatBalance(_ctx.balance),
            channels: _ctx.channels,
            "is-notify": _ctx.isNotify
          }, null, 8, ["balance", "channels", "is-notify"]))
    ]),
    _createVNode(_component_router_view)
  ], 4))
}